import React from "react"
import AppToaster from "utils/AppToaster"
import CustomDialog from "../Atoms/CustomDialog"
import ButtonMutation from "../Molecules/ButtonMutation"

const MutationDialog = ({
  intent = undefined,
  itemType = undefined,
  isOpen,
  mutation,
  variables,
  title,
  onClose,
  refetchQueries = undefined,
  optimisticResponse = undefined,
  update = undefined,
  children,
  onCompleted,
  text = undefined,
  ...otherProps
}) => {
  return (
    <CustomDialog
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      footerRightButton={
        <ButtonMutation
          icon="confirm"
          text={text}
          mutation={mutation}
          variables={variables}
          refetchQueries={refetchQueries}
          optimisticResponse={optimisticResponse}
          update={update}
          onCompleted={onCompleted}
          onError={err => {
            AppToaster.show({
              message: "Unable to save the " + itemType,
              intent: "danger",
            })
          }}
          intent={intent}
          dark={intent ? false : true}
        />
      }
      {...otherProps}
    >
      {children}
    </CustomDialog>
  )
}
MutationDialog.defaultProps = {
  text: "Change Vehicle",
}
export default MutationDialog
